import { Logo3Icon } from '../assets/icons'

export default function Splash() {
  return (
    <div className="splash">
      <Logo3Icon className="animate-ping" />
    </div>
  )
}
